module.exports = __webpack_public_path__ + "static/media/02.814bc3fa.mp3";